import {
  Badge,
  Box,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdCheckCircle, MdError, MdUpload } from 'react-icons/md'

import FuModalHeader from './ModalHeader'

export type ImportarCSVErro = {
  linha: number
  pedido: string
  centro: string
  codigoProduto: string
  campo: string
  mensagem: string
}

export type ImportarCSVResultado = {
  success: boolean
  message: string
  data?: {
    totalLinhas: number
    aplicadas: number
    ignoradas: number
    comErro: number
    erros: ImportarCSVErro[]
  }
}

type Props = {
  resultado: ImportarCSVResultado | null
  onClose: () => void
}

const ImportarCSVModal: FC<Props> = ({ resultado, onClose }) => {
  if (!resultado) return null

  const { success, message, data } = resultado
  const temErros = !success && data && data.erros && data.erros.length > 0
  const erroArquivo = !success && !data

  return (
    <Modal
      isOpen={!!resultado}
      onClose={onClose}
      isCentered
      scrollBehavior="inside"
      size={temErros ? '5xl' : 'lg'}
    >
      <ModalOverlay />
      <ModalContent>
        <FuModalHeader
          icon={success ? MdCheckCircle : MdError}
          title={
            success ? 'Importação realizada com sucesso' : 'Falha na importação'
          }
          bg={success ? '#1d5840' : '#c53030'}
        />
        <ModalCloseButton color="white" top={3} />

        <ModalBody bg="white" py={5} px={5}>
          <Text
            fontSize="15px"
            fontWeight="600"
            color={success ? 'green.700' : 'red.600'}
            mb={data ? 4 : 0}
          >
            {message}
          </Text>

          {data && (
            <>
              {data.comErro > 0 && (
                <Badge
                  colorScheme="red"
                  borderRadius="full"
                  px={3}
                  py={1}
                  mb={4}
                  fontSize="12px"
                >
                  {data.comErro} linha{data.comErro !== 1 ? 's' : ''} com erro
                </Badge>
              )}

              {temErros && (
                <Box overflowX="auto">
                  <Text
                    fontSize="12px"
                    fontWeight="700"
                    color="gray.500"
                    letterSpacing="0.8px"
                    textTransform="uppercase"
                    mb={2}
                  >
                    Detalhes dos erros
                  </Text>
                  <Table size="sm">
                    <Thead bg="gray.50">
                      <Tr>
                        <Th>Linha</Th>
                        <Th>Pedido</Th>
                        <Th>Centro</Th>
                        <Th>Produto</Th>
                        <Th>Campo</Th>
                        <Th>Mensagem</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.erros.map((erro, i) => (
                        <Tr key={i} _hover={{ bg: 'red.50' }}>
                          <Td>
                            <Badge colorScheme="red" borderRadius="full" px={2}>
                              {erro.linha}
                            </Badge>
                          </Td>
                          <Td fontSize="12px">{erro.pedido}</Td>
                          <Td fontSize="12px">{erro.centro}</Td>
                          <Td fontSize="12px">{erro.codigoProduto}</Td>
                          <Td>
                            <Badge colorScheme="orange" fontSize="10px">
                              {erro.campo}
                            </Badge>
                          </Td>
                          <Td fontSize="12px" color="red.600" maxW="300px">
                            {erro.mensagem}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              )}
            </>
          )}
        </ModalBody>

        <ModalFooter bg="white" borderBottomRadius={5} gap={2}>
          {!success && (
            <Text fontSize="12px" color="gray.400" mr="auto">
              Nenhum item foi gravado — corrija o arquivo e reenvie.
            </Text>
          )}
          <Button
            bg={success ? '#0f5238' : 'gray.100'}
            color={success ? 'white' : 'gray.700'}
            _hover={{ bg: success ? '#1d5840' : 'gray.200' }}
            leftIcon={<Icon as={MdUpload} />}
            onClick={onClose}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ImportarCSVModal
